// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contato_secao__Necs2 {
  padding: 6rem 1.5rem;
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
}

.Contato_etiqueta__CZwBo {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  color: hsl(217, 91%, 60%);
  margin-bottom: 1rem;
  display: block;
}

.Contato_titulo__ndx6r {
  font-size: 2.5rem;
  font-weight: 800;
  color: hsl(210, 40%, 95%);
  margin-bottom: 1rem;
}

.Contato_descricao__XJY7S {
  color: hsl(215, 20%, 55%);
  font-size: 1rem;
  line-height: 1.7;
  margin-bottom: 2.5rem;
}

.Contato_links__MyKU3 {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.Contato_link__qNCa- {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.85rem 1.5rem;
  background: hsl(222, 44%, 9%);
  border: 1px solid hsl(222, 30%, 18%);
  border-radius: 0.75rem;
  color: hsl(210, 40%, 92%);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.Contato_link__qNCa-:hover {
  border-color: hsl(217, 91%, 60%, 0.4);
  background: hsl(217, 91%, 60%, 0.05);
  transform: translateY(-2px);
}

.Contato_linkIcone__xmi2l {
  width: 1.1rem;
  height: 1.1rem;
  opacity: 0.7;
}
`, "",{"version":3,"sources":["webpack://./src/components/Contato/Contato.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;AACd","sourcesContent":[".secao {\n  padding: 6rem 1.5rem;\n  max-width: 700px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.etiqueta {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 0.8rem;\n  color: hsl(217, 91%, 60%);\n  margin-bottom: 1rem;\n  display: block;\n}\n\n.titulo {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: hsl(210, 40%, 95%);\n  margin-bottom: 1rem;\n}\n\n.descricao {\n  color: hsl(215, 20%, 55%);\n  font-size: 1rem;\n  line-height: 1.7;\n  margin-bottom: 2.5rem;\n}\n\n.links {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.85rem 1.5rem;\n  background: hsl(222, 44%, 9%);\n  border: 1px solid hsl(222, 30%, 18%);\n  border-radius: 0.75rem;\n  color: hsl(210, 40%, 92%);\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.link:hover {\n  border-color: hsl(217, 91%, 60%, 0.4);\n  background: hsl(217, 91%, 60%, 0.05);\n  transform: translateY(-2px);\n}\n\n.linkIcone {\n  width: 1.1rem;\n  height: 1.1rem;\n  opacity: 0.7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secao": `Contato_secao__Necs2`,
	"etiqueta": `Contato_etiqueta__CZwBo`,
	"titulo": `Contato_titulo__ndx6r`,
	"descricao": `Contato_descricao__XJY7S`,
	"links": `Contato_links__MyKU3`,
	"link": `Contato_link__qNCa-`,
	"linkIcone": `Contato_linkIcone__xmi2l`
};
export default ___CSS_LOADER_EXPORT___;
